import React from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox as AntCheckbox, CheckboxProps } from 'antd';

interface Props extends CheckboxProps {
  control: any;
  inputName: string;
  label: string | JSX.Element;
  error: any;
  checked?: boolean;
  callback?: () => void;
}

export default function Checkbox({
  control,
  inputName,
  checked = false,
  label,
  ...props
}: Props) {
  return (
    <Controller
      control={control}
      name={inputName}
      // rules={rules}
      defaultValue={checked}
      render={({ field: { onChange, value } }) => (
        <AntCheckbox
          {...props}
          value={value}
          onChange={e => onChange(e.target.checked)}
          className={'custom-checkbox'}
          checked={value}
        >
          {label}
        </AntCheckbox>
      )}
    />
  );
}
